'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModuleCreditBail", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Cr\xE9dit bail\" class=\"mr-s module-credit-bail \">Cb</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-credit-bail.js
// module id = 2855
// module chunks = 13